import {
  put,
  select,
  takeEvery,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects';
import { callApi, callApiNext } from 'helpers/saga-helpers';
import { get, isNull } from 'lodash';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import {
  setSagisClaim,
  setJudgementOnMeritsByVictims,
  setJudgementOnMeritsByVehicles,
  setEncryptedDocuments,
  setMaterialEncryptedDocuments,
  setAssignedLawyers,
  setRegulations,
  setCreatedRegulations,
  requestCreateSummarySheetRegulation,
  setRegulation,
  requestSagisClaimInfo,
  requestGetRegulation as getRegulationAction,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION,
  REQUEST_CREATE_CORPOREAL_REGULATION,
  REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT,
  REQUEST_CREATE_MATERIAL_REGULATION,
  REQUEST_CREATE_SUMMARY_SHEET_REGULATION,
  REQUEST_GET_ASSIGNED_LAWYERS,
  REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  REQUEST_GET_REGULATION,
  REQUEST_GET_REGULATIONS,
  REQUEST_MATERIAL_ENCRYPTED_DOCUMENT,
  REQUEST_SAGIS_CLAIM_INFO,
  REQUEST_VALIDATE_PROVISION,
  REQUEST_VALIDATE_REGULATION,
  UPLOAD_DOCUMENT_REGULATION,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import {
  ICorporealRegulationAction,
  IEncryptedDocumentAction,
  IMaterialEncryptedDocumentAction,
  IMaterialRegulationAction,
  summarySheetRegulationAction,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/typings';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import {
  resetUploadDocumentStore,
  setUploadDocument,
} from 'containers/UploadDocuments/actions';
import userToken from 'containers/services/security/access-token-storage';
import { requestGetTransaction } from 'containers/TransactionManagerTimeLine/actions';

export function* getSagisClaim(action: any): Generator<unknown> {
  const claimNumber = action.claimNumber;
  const token = accessTokenStorage.get()?.token
    ? accessTokenStorage.get()?.token
    : yield select(makeSelectKeycloakToken());
  if (!claimNumber) return null;
  const path = accessTokenStorage.get()?.token
    ? `/corporeal/claim-sagis/${claimNumber}`
    : `/corporeal/claim-sagis/${claimNumber}?isIntervenant=true`;
  if (isNull(token)) return;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  const errorResponse = yield callApi(path, {}, options, [], setSagisClaim);
  if (!errorResponse && action.successCallback) {
    yield action.successCallback();
  }
}

export function* getSagisClaimSaga() {
  yield takeLeading(REQUEST_SAGIS_CLAIM_INFO, getSagisClaim);
}
export function* requestJudgementOnMeritsByVictims(action: {
  type: string;
  claimId: number;
  victims: number[];
  beneficiaries: number[];
  procedureNatureId: number;
}) {
  const { claimId, victims, beneficiaries, procedureNatureId } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/judgement/judgement-on-merits-by-victims`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimId,
      victims,
      beneficiaries,
      procedureNatureId,
    }),
  };

  yield callApi(path, {}, options, [], setJudgementOnMeritsByVictims);
}

export function* getJudgementOnMeritsByVictimsSaga() {
  yield takeLeading(
    REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
    requestJudgementOnMeritsByVictims,
  );
}
export function* requestGetRegulations(action: {
  type: string;
  claimId: number;
}) {
  const { claimId } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/regulation?claimId=${claimId}`;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setRegulations);
}

export function* getRegulationsSaga() {
  yield takeLeading(REQUEST_GET_REGULATIONS, requestGetRegulations);
}
export function* requestJudgementOnMeritsByVehicles(action: {
  type: string;
  claimId: number;
  vehicles: number[];
  procedureNatureId: number;
  courtNumber: string;
}) {
  const { claimId, vehicles, courtNumber, procedureNatureId } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/judgement/judgement-on-merits-by-vehicles`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimId,
      vehicles,
      procedureNatureId,
      courtNumber,
    }),
  };

  yield callApi(path, {}, options, [], setJudgementOnMeritsByVehicles);
}
export function* getJudgementOnMeritsByVehiclesSaga() {
  yield takeLeading(
    REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
    requestJudgementOnMeritsByVehicles,
  );
}
export function* createCorpoEncryptedDocumentSaga() {
  yield takeLeading(
    REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT,
    createCorpoEncryptedDocument,
  );
}
export function* createCorpoEncryptedDocument(
  action: IEncryptedDocumentAction,
): Generator<unknown> {
  const { corporealEncryptedDocuments, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/add-incrypted-document`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(corporealEncryptedDocuments),
  };
  const errorResponse = yield callApi(
    path,
    {},
    options,
    [],
    setEncryptedDocuments,
  );

  if (!errorResponse) {
    yield successCallback();
  }
}
export function* materialEncryptedDocumentSaga() {
  yield takeLeading(
    REQUEST_MATERIAL_ENCRYPTED_DOCUMENT,
    materialEncryptedDocument,
  );
}
export function* materialEncryptedDocument(
  action: IMaterialEncryptedDocumentAction,
): Generator<unknown> {
  const { materialEncryptedDocuments, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/material-incrypted-document`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(materialEncryptedDocuments),
  };

  const errorResponse = yield callApi(
    path,
    {},
    options,
    [],
    setMaterialEncryptedDocuments,
  );

  if (!errorResponse) {
    yield successCallback();
  }
}
export function* createCorporealRegulationSaga() {
  yield takeLeading(
    REQUEST_CREATE_CORPOREAL_REGULATION,
    createCorporealRegulation,
  );
}

export function* createCorporealRegulation(
  action: ICorporealRegulationAction,
): Generator<unknown> {
  const { corporealRegulation, successCallback, failCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/add-corporeal-regulation`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(corporealRegulation),
  };
  const errorResponse = yield callApi(
    path,
    {},
    options,
    [],
    setCreatedRegulations,
  );

  if (!errorResponse) {
    yield successCallback();
  } else {
    yield failCallBack();
  }
}
export function* createMaterialRegulationSaga() {
  yield takeLeading(
    REQUEST_CREATE_MATERIAL_REGULATION,
    createMaterialRegulation,
  );
  yield takeLeading(
    REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION,
    createMaterialRegulation,
  );
}
export function* createMaterialRegulation(
  action: IMaterialRegulationAction,
): Generator<unknown> {
  const { materialRegulation, claimNumber, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/add-material-regulation/${claimNumber}`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(materialRegulation),
  };
  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield successCallback();
  }
}
export function* requestGetAssignedLawyers(action: {
  type: string;
  lawyers: number[];
}) {
  const { lawyers } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/get-assigned-lawyer/${JSON.stringify(lawyers)}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setAssignedLawyers);
}
export function* getAssignedLawyersSaga() {
  yield takeLeading(REQUEST_GET_ASSIGNED_LAWYERS, requestGetAssignedLawyers);
}
export function* createSummarySheetRegulationSaga() {
  yield takeLatest(
    REQUEST_CREATE_SUMMARY_SHEET_REGULATION,
    createSummarySheetRegulation,
  );
}
export function* createSummarySheetRegulation(
  action: summarySheetRegulationAction,
): Generator<unknown> {
  const { summarySheet, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/summary-sheet-regulation/add`;

  const options = {
    method: 'POST',
    body: JSON.stringify(summarySheet),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield successCallback();
    yield put(resetUploadDocumentStore());
  }
}

export function* uploadDocumentRegulation(action: any): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  const path = '/corporeal/v1/upload-documents';
  const formData = new FormData();
  formData.append('document', get(action, 'uploadFile.base64Url'));
  const options = {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let response: any;
  response = yield callApiNext(path, {}, options, [], setUploadDocument);
  if (response?.data) {
    yield put(
      requestCreateSummarySheetRegulation(
        get(action, 'uploadFile.sheet', []).map((item: any) => ({
          ...item,
          url: get(response, 'data.response'),
        })),
        get(action, 'uploadFile.successCallBack'),
      ),
    );
  }
}

export function* uploadDocumentRegulationSaga() {
  yield takeEvery(UPLOAD_DOCUMENT_REGULATION, uploadDocumentRegulation);
}

export function* requestGetRegulation(action: {
  type: string;
  paymentId: number;
  isTransaction?: boolean;
}) {
  const { paymentId, isTransaction } = action;
  const token = accessTokenStorage.get().token;
  const path = isTransaction
    ? `/corporeal/regulation/victim/${paymentId}`
    : `/corporeal/regulation/${paymentId}`;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setRegulation);
}

export function* requestGetRegulationSaga() {
  yield takeLatest(REQUEST_GET_REGULATION, requestGetRegulation);
}
export function* requestUpdateProvision(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/regulation-provision`;
  const { claimNumber, ...rest } = payload;
  const options = {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...rest,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    if (claimNumber) {
      yield put(requestSagisClaimInfo(claimNumber, successCallback));
    }
  }
}

export function* requestUpdateProvisionSaga() {
  yield takeLeading(REQUEST_VALIDATE_PROVISION, requestUpdateProvision);
}

export function* requestValidateRegulation(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/regulation/validate`;
  const { claimNumber, ...rest } = payload;
  const options = {
    method: 'PUT',
    headers: {
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      claimNumber,
      ...rest,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    if (claimNumber && payload.paymentId) {
      yield successCallback();
      yield put(requestSagisClaimInfo(claimNumber, () => {}));
      if (payload.isTransaction) {
        yield put(getRegulationAction(payload.victimId, true));
        yield put(
          requestGetTransaction({
            claimId: payload.claimId,
            isIntervenant: false,
          }),
        );
      } else {
        yield put(getRegulationAction(payload.paymentId));
      }
    }
  }
}

export function* requestValidateRegulationSaga() {
  yield takeLeading(REQUEST_VALIDATE_REGULATION, requestValidateRegulation);
}
export default [
  getSagisClaimSaga,
  getJudgementOnMeritsByVictimsSaga,
  getJudgementOnMeritsByVehiclesSaga,
  createCorpoEncryptedDocumentSaga,
  createCorporealRegulationSaga,
  materialEncryptedDocumentSaga,
  createMaterialRegulationSaga,
  getAssignedLawyersSaga,
  getRegulationsSaga,
  createSummarySheetRegulationSaga,
  uploadDocumentRegulationSaga,
  requestGetRegulationSaga,
  requestUpdateProvisionSaga,
  requestValidateRegulationSaga,
];
